import React from "react";
import { darken, lighten } from "material-ui/utils/colorManipulator";
import ReactTooltip from "react-tooltip";
import { getColorForTag } from "../../../util";

import TicketStore from "../../../stores/TicketStore";

class EventGridRowItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventIsDated: props.event.is_dated
    };

    this._onClick = this._onClick.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object,
    router: React.PropTypes.object
  };

  _onClick(id) {
    this.context.router.push({
      pathname: `/schedule/${id}`,
      state: { fromSchedule: true }
    });
  }

  getStyles() {
    return {
      eventItem: {
        border: "1px solid",
        transition: "0.1s ease-in-out",
        backgroundColor: "#fff",
        padding: "0.2em",
        boxSizing: "border-box",
        cursor: "pointer",
        overflow: "hidden"
        // ':hover': {
        //   transform: 'scale(1.1)',
        //   zIndex: 1
        // }
      },
      eventItemName: {
        fontSize: "1.1em",
        fontWeight: "bold",
        lineHeight: 1.2,
        marginBottom: 3
      },
      eventItemSub: {
        fontSize: "0.8em",
        lineHeight: 1.5
      },
      eventItemWrapper: {
        position: "relative"
      },
      eventItemToolTip: {
        maxWidth: 300
      },
      startTime: {
        fontWeight: "normal",
        color: "rgba(1,1,1,0.4)"
      },
      ticketCountIcon: {
        fontSize: "0.85em"
      },
      ticketCount: {
        position: "absolute",
        bottom: 0,
        right: 0,
        padding: "2px 5px",
        borderTopLeftRadius: 5,
        fontWeight: "bold",
        backgroundColor: "rgba(0,0,0,0.6)",
        color: "#fff"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      theEvent = this.props.event,
      rowHeight = this.props.rowHeight,
      backgroundColor = theEvent.tags.length
        ? getColorForTag(
            theEvent.tags[0],
            true,
            this.context.tenant.schedule_invert_colors ? 0.5 : 0.4,
            this.context.tenant
          )
        : "#ccc",
      ticketCount =
        (theEvent.person && theEvent.person.ticket_count) ||
        TicketStore.getTicketsByEventId(theEvent.id).length ||
        0,
      numHours = this.state.eventIsDated
        ? theEvent._end_date.diff(theEvent._start_date, "hours", true)
        : null,
      eventItemStyles = Object.assign({}, styles.eventItem, {
        backgroundColor: backgroundColor,
        border: `1px solid ${darken(backgroundColor, 0.5)}`,
        ":hover": {
          backgroundColor: lighten(backgroundColor, 0.5),
          zIndex: 1
        }
      });
    if (this.state.eventIsDated) {
      eventItemStyles = {
        ...eventItemStyles,
        width: "100%",
        position: "absolute",
        height: `${numHours * rowHeight}em`,
        marginTop: `${(theEvent._start_date.minutes() / 60) * rowHeight}em`
      };
    }
    return (
      <div key={`${theEvent.id}-wrapper`} style={styles.eventItemWrapper}>
        <div
          key={theEvent.id}
          style={eventItemStyles}
          onClick={() => this._onClick(theEvent.id)}
          data-tip
          data-for={theEvent.id}
        >
          <div style={styles.eventItemName}>
            {this.state.eventIsDated ? (
              <span style={styles.startTime}>
                {theEvent._start_date.format("h:mm")}
              </span>
            ) : null}
            &nbsp;
            {theEvent.name}
          </div>
          {this.state.eventIsDated ? (
            <div style={styles.eventItemSub}>
              {theEvent._start_date.twix(theEvent._end_date).format()}
            </div>
          ) : null}
          <div style={styles.eventItemSub}>{theEvent.venue.name}</div>
          {ticketCount ? (
            <div style={styles.ticketCount}>
              {ticketCount}{" "}
              <span
                style={styles.ticketCountIcon}
                className="icon-ticket"
              ></span>
            </div>
          ) : null}
        </div>
        <ReactTooltip id={theEvent.id} effect="solid">
          <div style={styles.eventItemToolTip}>
            {theEvent.short_description}
          </div>
        </ReactTooltip>
      </div>
    );
  }
}

export default EventGridRowItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/event-list/event-grid-row-item.jsx